import React, { useState } from 'react';
import { Alert, Box } from '@mui/material';
import {
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import { useUpdateApplicationStatusMutation } from '../../services/serviceJobsAccount';
import {
  IJobApplicationStatus,
  IJobsAccountApplicant,
  IJobsAccountApplicantsRequest,
} from '../../services/serviceJobsAccount/interfaces';
import { StageColumn } from './StageColumn';

export const ApplicantsBoard = ({ statuses, request, onOpen }: {
  statuses: IJobApplicationStatus[];
  request: IJobsAccountApplicantsRequest;
  onOpen: (applicant: IJobsAccountApplicant) => void;
}) => {
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor));
  const [updateStatus] = useUpdateApplicationStatusMutation();
  const [busyApplicationId, setBusyApplicationId] = useState<number | null>(null);
  const [hasError, setHasError] = useState(false);

  const onDragEnd = async (event: DragEndEvent) => {
    const applicant = event.active.data.current?.applicant as IJobsAccountApplicant | undefined;
    const statusId = event.over?.data.current?.statusId as number | undefined;
    if (!applicant || !statusId || applicant.statusId === statusId) return;
    setBusyApplicationId(applicant.applicationId);
    setHasError(false);
    try {
      await updateStatus({
        eguid: applicant.jobGuid,
        applicationId: applicant.applicationId,
        statusId,
      }).unwrap();
    } catch {
      setHasError(true);
    } finally {
      setBusyApplicationId(null);
    }
  };

  return (
    <>
      {hasError ? <Alert severity="error" sx={{ mb: 2 }}>We could not move that applicant.</Alert> : null}
      <DndContext sensors={sensors} onDragEnd={onDragEnd}>
        <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', pb: 2 }}>
          {[...statuses].sort((a, b) => a.sortOrder - b.sortOrder).map((status) => (
            <StageColumn
              key={status.id}
              status={status}
              baseRequest={request}
              busyApplicationId={busyApplicationId}
              onOpen={onOpen}
            />
          ))}
        </Box>
      </DndContext>
    </>
  );
};

export default ApplicantsBoard;
